import React, { useEffect, useState } from 'react'
import moment from 'moment'
import MobileSearchHeader from '../../components/mobile/mobileSearchHeader'
import MobileCard from '../../components/mobile/mobileCard'
import TripListItem from '../../components/mobile/tripListItem'
import MobileTripsFilter, { defaultTripsFilters } from '../../components/mobile/mobileTripsFilter'
import { myTripsService } from '../../functions/services/myTrips.service'

const defaultTake = 30

const formatAddress = address => {
   if (!address) return ''
   return [address.streetName, address.houseNumber, address.houseLetter, address.zipCode, address.district]
      .filter(part => part != null && part !== '')
      .join(' ')
}

// Same status text mapping as the desktop turStatus.js component.
const statusLabels = {
   3: 'Aktiv',
   4: 'Ferdig',
   5: 'Avbrutt'
}

// Same colour logic as getIconColor() in myTripsTable.js.
const getVehicleColor = trip => {
   if (trip.isManual) return 'text-blue-500'
   if (trip.cancelReason > 0) return 'text-gray-700'
   if (trip.bookingStatus < 4) return 'text-red-500'
   return 'text-green-500'
}

const mapTrip = trip => ({
   id: trip.bookingId,
   toAddress: formatAddress(trip.to),
   fromAddress: formatAddress(trip.from),
   pickupDate: trip.pickupTime ? moment(trip.pickupTime).format('DD.MM.YY') : '',
   pickupTime: trip.pickupTime ? moment(trip.pickupTime).format('HH:mm') : '',
   price: Math.round((trip.price || 0) / 100),
   category: trip.category,
   vehicleColor: getVehicleColor(trip),
   status: statusLabels[trip.bookingStatus] || '',
   bookingNumber: trip.bookingNumber
})

// Counts how many of the (non free-text) filter fields differ from their
// empty/default value, used to show a badge on the Filter button.
const countActiveTripsFilters = filters =>
   Object.entries(filters).reduce((count, [key, value]) => {
      if (key === 'status') return value !== 0 ? count + 1 : count
      return value ? count + 1 : count
   }, 0)

const MobileMyTrips = () => {
   const [search, setSearch] = useState('')
   const [filters, setFilters] = useState(defaultTripsFilters)
   const [filterOpen, setFilterOpen] = useState(false)
   const [trips, setTrips] = useState([])
   const [loading, setLoading] = useState(true)
   const [expandedId, setExpandedId] = useState(null)

   useEffect(() => {
      const searchModel = {
         searchString: search,
         fromAddress: filters.fromAddress || null,
         toAddress: filters.toAddress || null,
         stopAddress: null,
         status: filters.status,
         permitNumber: filters.permitNumber || null,
         from: filters.from || null,
         to: filters.to || null,
         bookingNumber: filters.bookingNumber || null,
         driverNumber: filters.driverNumber || null,
         regionName: filters.regionName || null,
         phoneNumber: filters.phoneNumber || null,
         orderField: 'createdDate',
         ascending: false,
         index: 0,
         take: defaultTake
      }

      setLoading(true)
      const timeoutId = setTimeout(() => {
         myTripsService.tripSearch(searchModel).then(
            response => {
               setTrips((response || []).map(mapTrip))
               setLoading(false)
            },
            error => {
               console.error('Error fetching trips:', error)
               setLoading(false)
            }
         )
      }, 300)

      return () => clearTimeout(timeoutId)
   }, [search, filters])

   return (
      <div>
         <MobileSearchHeader
            searchValue={search}
            onSearchChange={setSearch}
            onFilterClick={() => setFilterOpen(true)}
            activeFilterCount={countActiveTripsFilters(filters)}
         />

         <MobileTripsFilter
            open={filterOpen}
            onClose={() => setFilterOpen(false)}
            values={filters}
            onApply={setFilters}
         />

         <div className="p-4 pt-2 md:p-6 md:pt-2">
            <MobileCard noPadding>
               {loading ? (
                  <div className="p-4 text-center text-gray-500 md:text-lg">Laster...</div>
               ) : trips.length === 0 ? (
                  <div className="p-4 text-center text-gray-500 md:text-lg">Ingen turer funnet</div>
               ) : (
                  trips.map(trip => (
                     <TripListItem
                        key={trip.id}
                        trip={trip}
                        expanded={expandedId === trip.id}
                        onToggle={() => setExpandedId(expandedId === trip.id ? null : trip.id)}
                     />
                  ))
               )}
            </MobileCard>
         </div>
      </div>
   )
}

export default MobileMyTrips
